import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import { environment } from "../config/environment";

let supabaseClient: SupabaseClient | null = null;

export function getSupabaseClient(): SupabaseClient {
  if (!supabaseClient) {
    supabaseClient = createClient(environment.supabase.url, environment.supabase.anonKey, {
      auth: {
        // We manage our own persistence layer using Office.context.roamingSettings via session-store.ts
        // This prevents Supabase from using its own storage mechanisms
        persistSession: false,
        
        // We don't use URL-based session detection (no OAuth redirects in add-in)
        detectSessionInUrl: false,
        
        // Auto-refresh helps maintain sessions while the add-in is open.
        // However, since persistSession is false, Supabase won't automatically
        // persist the refreshed tokens - we handle that in auth-service.ts via
        // the auth state change listener and manual refresh logic on bootstrap.
        autoRefreshToken: true,
      },
    });
  }
  return supabaseClient;
}
